import type { ReactElement } from 'react';
import { Button } from '@/shared/ui';
import { useCreateRevisionDraft } from '../model/use-create-revision-draft';

export interface RevisionDraftButtonProps {
  readonly quoteRequestId: string;
}

/** 재발행 초안 만들기(견적 설계 §6-5) — 최신 발행본을 복사한 새 차수 초안. 만들면 상세가 다시 로드되어 편집기가 뜬다. */
export const RevisionDraftButton = ({ quoteRequestId }: RevisionDraftButtonProps): ReactElement => {
  const { createRevisionDraft, isPending, error } = useCreateRevisionDraft();

  return (
    <div className="flex flex-col gap-2">
      <div className="flex flex-wrap items-center gap-3">
        <Button
          variant="outline"
          isLoading={isPending}
          onClick={() => {
            void createRevisionDraft(quoteRequestId);
          }}
        >
          재발행 초안 만들기
        </Button>
        <span className="text-xs text-muted-foreground">
          최신 발행본을 복사해 새 차수 초안을 만듭니다(만료일은 오늘+7일).
        </span>
      </div>
      {error ? (
        <p role="alert" className="text-sm text-destructive">
          {error}
        </p>
      ) : null}
    </div>
  );
};
